"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.mergeForumsLimits = exports.FORUMS_COMMENT_EDIT_WINDOW_HOURS_MAX = exports.FORUMS_COMMENT_EDIT_WINDOW_HOURS_MIN = exports.FORUMS_COMMENT_MAX_LENGTH_MAX = exports.FORUMS_COMMENT_MAX_LENGTH_MIN = exports.DEFAULT_FORUMS_COMMENT_EDIT_WINDOW_HOURS = exports.DEFAULT_FORUMS_COMMENT_MAX_LENGTH = void 0;
exports.DEFAULT_FORUMS_COMMENT_MAX_LENGTH = 2000;
exports.DEFAULT_FORUMS_COMMENT_EDIT_WINDOW_HOURS = 24;
exports.FORUMS_COMMENT_MAX_LENGTH_MIN = 100;
exports.FORUMS_COMMENT_MAX_LENGTH_MAX = 5000;
exports.FORUMS_COMMENT_EDIT_WINDOW_HOURS_MIN = 1;
exports.FORUMS_COMMENT_EDIT_WINDOW_HOURS_MAX = 168;
var mergeForumsLimits = function (limits) { return ({
    forumsCommentMaxLength: typeof (limits === null || limits === void 0 ? void 0 : limits.forumsCommentMaxLength) === 'number' && limits.forumsCommentMaxLength >= exports.FORUMS_COMMENT_MAX_LENGTH_MIN
        ? Math.min(limits.forumsCommentMaxLength, exports.FORUMS_COMMENT_MAX_LENGTH_MAX)
        : exports.DEFAULT_FORUMS_COMMENT_MAX_LENGTH,
    forumsCommentEditWindowHours: typeof (limits === null || limits === void 0 ? void 0 : limits.forumsCommentEditWindowHours) === 'number' &&
        limits.forumsCommentEditWindowHours >= exports.FORUMS_COMMENT_EDIT_WINDOW_HOURS_MIN
        ? Math.min(limits.forumsCommentEditWindowHours, exports.FORUMS_COMMENT_EDIT_WINDOW_HOURS_MAX)
        : exports.DEFAULT_FORUMS_COMMENT_EDIT_WINDOW_HOURS,
}); };
exports.mergeForumsLimits = mergeForumsLimits;
//# sourceMappingURL=forumsLimits.js.map